import React from 'react';
import { useState, useEffect } from 'react';
import LoginPage from './login-page';
import ScreenSizePopup from './screen-size-popup';

const Login = () => {

    const [showModal, setShowModal] = useState(true);

    function useMediaQuery() {
        const [isBelow1000px, setIsBelow1000px] = useState(window.innerWidth < 1000);

        useEffect(() => {
            const mediaQueryListener = () => {
                setIsBelow1000px(window.innerWidth < 1000);
            };

            window.addEventListener('resize', mediaQueryListener);

            return () => {
                window.removeEventListener('resize', mediaQueryListener);
            };
        }, []);

        return isBelow1000px;
    }

    function onClose() {
        setShowModal(false);
    }

    const showModalForLowResolutions = useMediaQuery() && showModal;

    return (
        showModalForLowResolutions ? <ScreenSizePopup onClose={onClose} /> : <LoginPage />
    );
}

export default Login;